import React from "react";
import LocationPage from "./LocationPage";

export default function WebdesignAgenturVillach() {
  return <LocationPage locationKey="villach" />;
}
